import { View, Text, Pressable } from 'react-native';
import { useLinkTo, useRoute } from '@react-navigation/native';

import { Icons } from 'components/Icons';
import { getResponsiveSize } from 'utils/index';

const MenuNavigation: React.FC = () => {
  const linkTo = useLinkTo();
  const route = useRoute();
  const NavigationLink = [
    {
      icon: Icons.Streaming,
      title: 'Ao vivo',
      onPress() {
        linkTo('/band-ao-vivo');
      },
      opacity: route.path === '/band-ao-vivo',
    },
    {
      icon: Icons.ClapperboardPlay,
      title: 'Assista',
      onPress() {
        linkTo('/assista');
      },
      opacity: route.name === 'Videos',
    },
    {
      icon: Icons.Radio,
      title: 'Ouça',
      onPress() {
        linkTo('/ouca');
      },
      opacity: route.name === 'Listen',
    },
  ];

  return (
    <View
      style={{
        flexDirection: "row",
        gap: getResponsiveSize({ lg: 45, md: 20, sm: 20, base: 0 }),
        display: getResponsiveSize({ lg: 'flex', md: 'flex', sm: 'flex', base: 'none' }),
        marginLeft: 40,
      }}>
      {NavigationLink.map((menu) => {
        const IconComponent = menu.icon;
        const iconOpacity = menu.opacity ? 1 : 0.7;

        return (
          <Pressable
            key={menu.title}
            onPress={menu.onPress}
            style={{ flexDirection: 'row', alignItems: 'center' }}>
            <IconComponent
              width="18"
              height="18"
              stroke="currentColor"
              opacity={iconOpacity}
              style={{ color: "#FFF", marginRight: 8 }}
            />
            <Text
              style={{
                color: '#FFF',
                fontFamily: 'system-ui',
                fontSize: Number(getResponsiveSize({ lg: 18, md: 18, sm: 16, base: 14 })),
                fontWeight: '600',
                opacity: iconOpacity,
                textDecorationLine: 'none',
              }}>
              {menu.title}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
};

export default MenuNavigation;
